import React from 'react'
import { connect } from "react-redux";
import ItemEditComponent from './TextEdit';
import ClientSelectorComponent from './ClientSelectorComponent';
import Select from './SelectComponent'
import UsersComponent from './UsersComponent'
import Tile from './Tile'
import LineItemComponent from './LineItemComponent'
import DocumentView from './DocumentView'
import CommentComponent from './CommentComponent'
import DateEditComponent from './DateEdit'
import SwitchEditComponent from './SwitchEdit'
import ImageSelect from './ImageSelect'

class TemplateBuilderComponent extends React.Component {
  render() {
    let { component, key, obj, onChangeText,
      setShowInvoice,
      dispatchSelectInvoice,
      dispatchGetInvoice
    } = this.props;


    let permissions = (component && component.permissions) ? component.permissions : {};
    let status = undefined;

    if (this.props.template && this.props.template.statuses) {
      status = this.props.obj.status ? this.props.template.statuses.find(i => i.name == this.props.obj.status) : undefined;
      if (!status && this.props.obj.hasSchedule) {
        status = this.props.template.statuses.find(i => i.name == 'Scheduled');
      }
    }

    if (status) {
      status = status.id;
      if (component && component.permissions && component.permissions[status]) permissions = component.permissions[status];
      if (this.props.userGroup) if (component && component.permissions && component.permissions[status] && component.permissions[status][this.props.userGroup]) permissions = component.permissions[status][this.props.userGroup];
    }

    if (permissions && permissions.hide) return <></>

    switch (component.type) {
      case 'clientSelect':
        // The picker writes the selection to obj.entityId (not the component's
        // prop), so read it back from there — same as mobile. Keep the prop as
        // a fallback for legacy templates that stored it per-prop.
        return (<ClientSelectorComponent viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} onChangeText={onChangeText} prop={component.prop} value={obj.entityId ?? obj[component.prop]} />)
      case 'text':
        return (<ItemEditComponent type={component.proptype ?? 'text'} viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} onChangeText={onChangeText} prop={component.prop} value={obj[component.prop]} />);
      case 'textArea':
        return (<ItemEditComponent viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} multiline={true} onChangeText={onChangeText} prop={component.prop} value={obj[component.prop]} />);
      case 'date':
        return (<DateEditComponent viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} format={component.format} header={component.label} onChangeText={onChangeText} prop={component.prop} value={obj[component.prop]} />);
      case 'switch':
        return (<SwitchEditComponent viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} onChangeText={onChangeText} prop={component.prop} value={obj[component.prop]} />);
      case 'invoice':
        return (<Tile header={component.label} viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} showPage={setShowInvoice} setDocument={dispatchSelectInvoice} getDocument={dispatchGetInvoice} display={obj && !!obj._id} prop={component.prop} value={obj[component.prop]} />);
      case 'document':
        return (<>{this.props.appointment && <DocumentView auth={this.props.auth} companyId={this.props.appointment.companyId} appointmentId={this.props.appointment._id} templateId={component.templateId} header={component.label} viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} />}</>);
      case 'wording':
        // Wording components are the template's section markers — render them
        // as proper section headings with a divider rule.
        return (<div key={key} style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0 10px' }}>
          <span style={{ fontFamily: 'var(--font-display, inherit)', fontWeight: 800, fontSize: 12.5, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--primary-dark, #067886)', whiteSpace: 'nowrap' }}>{component.label}</span>
          <span style={{ flex: 1, height: 1, background: 'rgba(15,31,46,0.10)' }}></span>
        </div>);
      case 'select':
        return (<Select viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} options={component.options} onChangeText={onChangeText} prop={component.prop} value={obj[component.prop]} />);
      case 'itemsSelect':
        console.log('itemsSelect',permissions)
        return (<LineItemComponent entityId={obj.entityId} permissions={permissions} key={key} updateLineItems={onChangeText} updateDiscount={onChangeText} prop={component.prop} discount={obj.discount} lineItems={obj.lineItems} />);
      case 'usersSelect':
        return (<UsersComponent viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} button={component.button} header={component.label} updateLineItems={onChangeText} prop={component.prop} lineItems={obj[component.prop]} />);
      case 'userSigniture': {
        // Mobile stores the signing user's id (UserSignComponent). Web is
        // read-only: resolve the id to a name; capture happens on mobile.
        const signedById = obj[component.prop];
        const users = (this.props.company && this.props.company.users) || [];
        const signedBy = users.find(u => u.userId == signedById || u._id == signedById);
        return (<div key={key} style={{ margin: '10px 0' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4 }}>{component.label}</div>
          {signedById
            ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 12px', borderRadius: 8, background: 'rgba(27,159,105,0.10)', border: '1px solid rgba(27,159,105,0.30)', color: 'var(--success)', fontSize: 13, fontWeight: 600 }}>
                <i className="fas fa-user-check"></i> Signed off{signedBy ? ' by ' + signedBy.name : ''}
              </span>
            : <span style={{ fontSize: 12, color: 'var(--text-muted)' }}><i className="fas fa-mobile-alt" style={{ marginRight: 6 }}></i>Not signed off yet — done in the mobile app.</span>}
        </div>);
      }
      case 'signiture': {
        // Mobile stores raw base64 PNG (SignEdit). Web is read-only.
        const data = obj[component.prop];
        return (<div key={key} style={{ margin: '10px 0' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4 }}>{component.label}</div>
          {data
            ? <img alt={component.label} style={{ width: 200, background: '#fff', border: '1px solid rgba(15,31,46,0.12)', borderRadius: 10, padding: 6 }} src={`data:image/jpeg;base64,${data}`} />
            : <span style={{ fontSize: 12, color: 'var(--text-muted)' }}><i className="fas fa-signature" style={{ marginRight: 6 }}></i>No signature yet — captured in the mobile app.</span>}
        </div>);
      }
      case 'images':
        return (<ImageSelect navigation={this.props.navigation} viewOnly={permissions ? permissions.viewOnly : component.viewOnly} key={key} header={component.label} prop={component.prop} onChangeText={this.props.onChangeText} value={this.props.obj[component.prop]} />);
      case 'comments':
        return (<CommentComponent prop={component.prop} onChangeText={onChangeText} value={obj[component.prop]} />)
      default:
        return (<></>)
    }
  }
};

const mapStateToProps = state => ({
  // userSigniture stores a userId — resolve to a name for the read-only web view.
  company: state.companies.company,
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateBuilderComponent)